import lang from 'lang'
import { subscriptionTypes } from '@/modules/base/util/constants'

const planLangMapping = {
  [subscriptionTypes.S_2021_2]: 's',
  [subscriptionTypes.M_2021_2]: 'm',
  [subscriptionTypes.L_2021_2]: 'l',
  [subscriptionTypes.XL_2021]: 'xl',
  [subscriptionTypes.FREE_2025]: 'free',
  [subscriptionTypes.XS_2025]: 'xs',
  [subscriptionTypes.S_2025]: 's',
  [subscriptionTypes.M_2025]: 'm',
  [subscriptionTypes.L_2025]: 'l',
  [subscriptionTypes.BUCHHALTUNG_2026]: 'buchhaltung',
  [subscriptionTypes.AUFTRAG_2026]: 'auftrag',
  [subscriptionTypes.AUFTRAG_PRO_2026]: 'auftragPro',
  [subscriptionTypes.WARENWIRTSCHAFT_2026]: 'warenwirtschaft',
  [subscriptionTypes.DOCUMENT_S]: subscriptionTypes.DOCUMENT_S,
  [subscriptionTypes.DOCUMENT_M]: subscriptionTypes.DOCUMENT_M,
  [subscriptionTypes.DOCUMENT_L]: subscriptionTypes.DOCUMENT_L,
  [subscriptionTypes.DOCUMENT_L_ERP]: subscriptionTypes.DOCUMENT_L_ERP,
  [subscriptionTypes.STAFF_S]: subscriptionTypes.STAFF_S,
  [subscriptionTypes.STAFF_M]: subscriptionTypes.STAFF_M,
  [subscriptionTypes.STAFF_L]: subscriptionTypes.STAFF_L,
  [subscriptionTypes.STAFF_XL]: subscriptionTypes.STAFF_XL,
}

const getPlanDescriptions = (name, features = []) => {
  const { user } = features
  const isOrgamax = ENV.product === 'orgamax'
  let text = ''
  const limits = []

  if (!name.includes('gmi')) {
    limits.push(
      {
        label: lang.upgradeModal.plans.user,
        count: user.includedCount - (name.includes('document')),
      },
    )
    if (isOrgamax) {
      if (planLangMapping[name] && lang.upgradeModal.plans[planLangMapping[name]]) {
        limits.push(...lang.upgradeModal.plans[planLangMapping[name]])
      }
    }
  } else {
    text = lang.upgradeModal.plans.planXlHint
  }

  return {
    text,
    limits,
  }
}

// keep for later purpose (dynamic description)
// const getPlanDescriptions = (name, features = []) => {
//   const {
//     sales,
//     documentCount,
//     storageSpace,
//     invoiceCount,
//     customerCount,
//     ...featureObjects
//   } = features

//   let text = ''
//   const limits = []

//   if (name !== subscriptionTypes.XL_2021) {
//     if (storageSpace) {
//       limits.push(
//         {
//           label: lang.upgradeModal.features.storageSpace,
//           count: `${storageSpace} ${lang.upgradeModal.features.gigabyte}`,
//         })
//     }
//     if (invoiceCount) {
//       limits.push(
//         {
//           label: lang.upgradeModal.features.invoiceCount,
//           count: invoiceCount,
//         })
//     }
//     if (customerCount) {
//       limits.push(
//         {
//           label: lang.upgradeModal.features.customerCount,
//           count: customerCount,
//         })
//     }
//     if (documentCount) {
//       limits.push(
//         {
//           label: lang.upgradeModal.features.documentCount,
//           count: documentCount,
//         })
//     }

//     Object.keys(featureObjects).forEach(key => {
//       const {
//         includedCount,
//         moduleEnabled,
//         bookableCount,
//         price,
//         bookable,
//         title,
//         disabled,
//         used,
//       } = featureObjects[key]
//       if (moduleEnabled) {
//         limits.push(
//           {
//             key,
//             label: lang.upgradeModal.features[key],
//             count: includedCount,
//             disabled,
//           },
//         )
//       }
//     })
//   } else {
//     text = lang.upgradeModal.plans.planXlHint
//   }

//   return {
//     text,
//     limits,
//   }
// }

export default getPlanDescriptions
